import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box } from 'rebass';
import { string, func } from 'prop-types';
import join from 'url-join';

import http from '~APP_UTIL/http';
import { getAccountAddressesColumns } from './accountAddressesColumns';

import { selectAdminAccount } from '../actions';

import { getSelectedAccount, getSelectedAccountId } from '../selectors';
import TableClientSide from '../../../components/tableClientSide/TableClientSide';

import { handleErrorNoAction } from '../../util';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

const AccountAddresses = ({ selectAdminAccount, selectedAccountId, selectedAccountNumber }) => {
  const { id } = useParams();
  const [addresses, setAddresses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    // force account selection if user refreshes the page
    if (id && !selectedAccountId) {
      selectAdminAccount(id);
    }
  }, []);

  useEffect(() => {
    const fetchAccountAddresses = async selectedAccountNumber => {
      setIsLoading(true);

      const response = await http.get(join(api2, `/accounts/${selectedAccountNumber}/addresses`));

      setAddresses(response?.data?.addresses);

      setIsLoading(false);
    };

    if (selectedAccountNumber) {
      fetchAccountAddresses(selectedAccountNumber);
    }
  }, [selectedAccountNumber]);

  const toggleAddress = async ({ toggle, addressNumber, soldTo }) =>
    http
      .post(join(api2, `/accounts/${soldTo}/${toggle}Address`), { addressNumber })
      .catch(error => handleErrorNoAction(dispatch, error));

  const memoizedColumns = useMemo(() => getAccountAddressesColumns({ toggleAddress }), []);

  const getAccountAddressActionItems = () => {
    return {};
  };

  return (
    <Box width='100%'>
      <TableClientSide
        columns={memoizedColumns}
        data={addresses}
        isLoading={isLoading}
        getActionItems={getAccountAddressActionItems}
        fullHeight
      />
    </Box>
  );
};

AccountAddresses.propTypes = {
  selectedAccountId: string.isRequired,
  selectAdminAccount: func.isRequired,
  selectedAccountNumber: string.isRequired
};

const mapStateToProps = state => ({
  selectedAccountId: getSelectedAccountId(state),
  selectedAccountNumber: getSelectedAccount(state)?.number || ''
});

const mapDispatchToProps = { selectAdminAccount };

export default connect(mapStateToProps, mapDispatchToProps)(AccountAddresses);
